import React from 'react';
import {
  ContactBanner,
  ContactBannerContent,
  ContactBannerEyebrow,
  ContactBannerTitle,
  ContactBannerDescription,
  ContactBannerActions,
} from './ExploreProducts.styles';

import PrimaryButton from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../Components/Buttons/SecondaryButton/SecondaryButton.component';

const handleContact = () => {
  window.location.href = '/contact-us';
};

const ContactEnd = () => {
  return (
    <ContactBanner>
      <ContactBannerContent>
        <div>
          <ContactBannerEyebrow>
            Looking for Something Specific?
          </ContactBannerEyebrow>

          <ContactBannerTitle>
            Tell Us What Your Workplace Needs
          </ContactBannerTitle>

          <ContactBannerDescription>
            The catalogue may not show every product available through our
            supplier network. Contact our team with a product name, category,
            brand, application, or workplace requirement and we will help narrow
            down the options.
          </ContactBannerDescription>
        </div>

        <ContactBannerActions>
          <PrimaryButton functionName={handleContact} span="Contact Our Team" />
          <SecondaryButton
            functionName={() => (window.location.href = 'tel:')}
            span="Call Us"
          />
        </ContactBannerActions>
      </ContactBannerContent>
    </ContactBanner>
  );
};

export default ContactEnd;
